var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?_c('div',{staticClass:"ad",attrs:{"id":"banner-ad"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }